import { TriCompanyPartnerService } from "@onetakesolutions/cargogo-contract-web/TriCompanyPartnerService_dubbo";
import { createPromiseClient } from "@apachedubbo/dubbo";
import transport from "../transport";

const client = createPromiseClient(TriCompanyPartnerService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
